import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const ServerConfigurationsApp = lazy(() => import('./ServerToolsApp'));

const PlayerReportsAppConfig = {
  settings: {
    layout: {}, 
  },
  auth: authRoles.admin,
  routes: [
    {
      path: 'apps/player-reports',
      element: <ServerConfigurationsApp />,
    },
  ],
};

export default PlayerReportsAppConfig;
